import type { ReactNode } from 'react'
import { VStack } from '@chakra-ui/react'
import { CallBatchesPanel } from './CallBatchesPanel'
import { FollowUpScriptEditor } from './FollowUpScriptEditor'
import { FOLLOW_UP_KIND_LABELS, type FollowUpKind, type FollowUpKindDto } from '../../../../types/followUp'

type Slots = Partial<Record<FollowUpKind | `custom:${string}`, ReactNode>>

const stack = (...nodes: ReactNode[]) => (
  <VStack align="stretch" gap={4} w="full" minW={0}>{nodes}</VStack>
)

/** CF-1 P4 slot builder for FollowUpTab (merge with mergeSectionSlots). Call-back gets call lists
 *  plus its script; Chase gets its script (P5 adds its own actions beside it); a custom call kind
 *  gets call lists plus script; a custom route kind gets only the conversation-route script.
 *  Sign drop-offs have no script. */
export function buildCallSectionSlots(campaignId: string, kinds: FollowUpKindDto[]): Slots {
  const slots: Slots = {
    CallBack: stack(
      <CallBatchesPanel key="batches" campaignId={campaignId} kind="CallBack" kindLabel={FOLLOW_UP_KIND_LABELS.CallBack} />,
      <FollowUpScriptEditor key="script" campaignId={campaignId} kind="CallBack" />,
    ),
    Chase: <FollowUpScriptEditor campaignId={campaignId} kind="Chase" />,
  }
  for (const k of kinds) {
    if (!k.isActive) continue
    slots[`custom:${k.id}`] = k.mode === 'Call'
      ? stack(
          <CallBatchesPanel key="batches" campaignId={campaignId} kind="Custom" customKindId={k.id} kindLabel={k.name} />,
          <FollowUpScriptEditor key="script" campaignId={campaignId} kind="Custom" customKindId={k.id} mode="Call" />,
        )
      : <FollowUpScriptEditor campaignId={campaignId} kind="Custom" customKindId={k.id} mode="Route" />
  }
  return slots
}
